import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="confirm"
export default class extends Controller {
  static values = {
    title: { type: String, default: '<Title Question?>' },
    text: { type: String, default: '<Whats your question?>' },
    yesLabel: { type: String, default: 'Yes' },
    noLabel: { type: String, default: 'No' },
    inputName: { type: String, default: '<object[attribute]>' }
  }

  connect () {
    // Ensure the target input exists in the DOM
    const input = this.element.querySelector(`input[name="${this.inputNameValue}"]`)
    if (!input) {
      console.error(`Input with name "${this.inputNameValue}" not found in the form.`)
      return
    }

    // Add an event listener to the button
    this.element.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault()
        const dialog = document.getElementById('turbo-confirm')
        dialog.querySelector('#modal-title').textContent = this.titleValue
        dialog.querySelector('p').textContent = this.textValue
        dialog.querySelector('button[value="confirm"]').textContent = this.yesLabelValue
        dialog.querySelector('button[value="cancel"]').textContent = this.noLabelValue
        dialog.showModal()

        dialog.addEventListener('close', () => {
          input.value = dialog.returnValue === 'confirm' ? 'true' : 'false'
          this.element.submit()
        }, { once: true })
      })
    })
  }
}
